import React, { memo, ReactNode, ReactText } from 'react'
import styles from './List.module.sass'
import clsx from 'clsx'
import { isEmpty } from 'fp-ts/es6/ReadonlyArray'
import { Classes } from '../../../../styles'

export interface ListProps<T> {
    className?: string,
    data: readonly T[],
    showEmpty?: boolean,
    render: (item: T) => ReactNode,
    toKey: (item: T) => ReactText,
    toClassName?: (item: T) => string,
    onClick?: (item: T) => void,
}

const List = <T extends unknown>(props: ListProps<T>) => <div className={clsx(props.className, styles.list, {[styles.interactive]: props.onClick})}>
    {
        props.showEmpty && isEmpty(props.data) ? <div className={clsx(styles.empty)}>
                Ничего не найдено
            </div> :
            props.data.map(item => <div
                key={props.toKey(item)}
                className={clsx(props.toClassName?.(item), styles.item, Classes.touchTarget)}
                onClick={() => props.onClick?.(item)}
            >
                {
                    props.render(item)
                }
            </div>)
    }
</div>

export default memo(List) as typeof List